import { useEffect } from "react";
import { TooltipFMEConstants, TooltipFMEManager } from "..";

const useMouseEvents = (props) => {
    useEffect(() => {
        return () => {
            TooltipFMEManager.invoke({ event: TooltipFMEConstants.LEAVE });
        };
    }, []);
    return {
        onMouseEnter: () => TooltipFMEManager.invoke({ event: TooltipFMEConstants.ENTER, ...props }),
        onMouseLeave: () => TooltipFMEManager.invoke({ event: TooltipFMEConstants.LEAVE }),
    };
};

export default useMouseEvents;
